import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { Gestao } from '../models/gestao.model';

@Injectable({
    providedIn: 'root'
})
export class GestaoService extends BaseService<Gestao> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/gestao`, injector);
    }
}
